import { render, staticRenderFns } from "./Classification.vue?vue&type=template&id=07f402bb&scoped=true"
import script from "./Classification.vue?vue&type=script&lang=js"
export * from "./Classification.vue?vue&type=script&lang=js"
import style0 from "./Classification.vue?vue&type=style&index=0&id=07f402bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f402bb",
  null
  
)

export default component.exports